<template>
    <router-link :to="`/treino/${workout.slug}${ workout.videos ? '' : '/list' }`" >
        <div @click="gaTrainButton" class="card workout-card" :class="`layout-${layout}`" v-if="workout">
            <img v-if="workout.thumbnail_header && layout == 'header'" :src="workout.thumbnail_header" class="workout-card__image workout-card__image-desktop">
            <img v-if="workout.thumbnail" :src="workout.thumbnail.file" class="workout-card__image" />

            <div class="workout-card__infos">
                <h4 class="card-title workout-card__title" v-html="$root.getTitle(workout)"></h4>
                <p class="card-description workout-card__description">{{ workout.description_header && layout == 'header' ? workout.description_header : workout.description }}</p>

                <div v-if="layout != 'header'" >
                    <button class="btn btn-lg btn-outline" >
                        {{ $root.t('Treine agora') }}
                    </button>
                </div>

                <slot></slot>
            </div>
        </div>
    </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props : {
        workout : {
            default : false
        },
        layout : {
            type : String,
            default : 'card'
        }
    },
    data () {
        return {
            cardSubWorkouts : false,
            activeOptions : false,
        }
    },
    computed : {
        ...mapGetters([ 'subWorkouts', 'workouts', 'theme' ])
    },
    watch : {
        workouts () {
            this.getSubWorkouts()
        }
    },
    created () {
        if ( this.workouts && this.workouts.length ) {
            this.getSubWorkouts()
        }
    },
    methods : {
        getSubWorkouts () {
            this.cardSubWorkouts = this.subWorkouts.filter ( w => w.parent == this.workout.ID  )
        },
        gaTrainButton() {
            if( this.layout !== 'header') {
                this.$gtm.trackEvent({
                    event: 'gaEvent',
                    eventCategory: `treine-em-casa-${this.theme}`,
                    eventAction: this.workout.title,
                    eventLabel: ''
                })
            }
        }
    }
}
</script>

<style lang="scss">
    @import "@/assets/scss/settings/_variables.scss";
    @import "@/assets/scss/settings/_mixins.scss";

    .workout-card {
        transition:  all .3s;
        max-height: 700px;

        &:after{
            content: '';
            height: 100%;
            background: linear-gradient(to bottom, transparent, black);
            z-index: -1;
            top: 0;
        }

        &_infos, &__image, &:after {
            position: absolute;
            left: 0;
            width: 100%;
        }

        &__image {
            top: 0;
            height: 100%;
            object-fit: cover;
            z-index: -2;
        }

        @include desktop {
            &__image-desktop + &__image {
                display: none;
            }
        }

        &__infos {
            bottom: 0;
            z-index: 10;
            padding: 15px;
            display: grid;
            grid-template-rows: 90px 130px 45px;

            h4, p {
                margin: 0;
            }
        }

        &__options {
            position: absolute;
            z-index: 12;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            background: rgba(0,0,0,0.6);
            padding: 20px;
            backdrop-filter: blur(2px);
            transition: all .6s;
            opacity: 0;
            pointer-events: none;
            transform: translateY(20px);

            &.active {
                opacity: 1;
                pointer-events: all;
                transform: translateY(0px);
            }

            > p {
                margin-top: 0;
                color: $c_primary;
                font-weight: bold;
                text-transform: uppercase;
            }
        }

        &__option {
            border: 1px solid $c_highlight;
            border-radius: 10px;
            padding: 5px 15px;
            font-size: 14px;
            color: lightgray;
            margin-bottom: 10px;
            background: rgba(0, 0, 0, 0.6);

            span {
                font-size: 18px;
                display: block;
                font-weight: 600;
                color: white
            }
        }

    }

    .workout-card.layout-card {
        border-radius: 10px;
        border: 2px solid transparent;
        padding-top: 62%;
        height: 100%;

        &:hover { border-color: $c_primary; }
    }

    .workout-card.layout-header {
        height: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        cursor: default;

        .workout-card__infos {
            padding: 40px 20px;
            max-width: 800px;
            width: 100vw;
        }

        @include tablet-up {
            .workout-card__description { font-size: 18px; }

            .workout-card__title {
                font-size: 16px;

                span { font-size: 48px; }
            }
        }
    }
</style>
